import React from 'react';

import { DestinationMarker } from './icons/destination-marker';
import { DriverMarker } from './icons/driver-marker';
import { StoreMarker, StoreMarkerRevamp } from './icons/store-marker';
import { StoreMarkerActive, StoreMarkerActiveRevamp } from './icons/store-marker-active';
import { StoreMarkerDisabled, StoreMarkerDisabledRevamp } from './icons/store-marker-disabled';
import { StoreMarkerFavorite, StoreMarkerFavoriteRevamp } from './icons/store-marker-fav';
import { StoreMarkerFavClosed, StoreMarkerFavClosedRevamp } from './icons/store-marker-fav-closed';
import { StoreMarkerInActive } from './icons/store-marker-inactive';
import { UserMarker } from './icons/user-marker';
import { IMarker, IMarkerInput, MarkerTypes } from './types';

export const deriveMarkerIcon = (type: MarkerTypes): React.ReactNode => {
  switch (type) {
    case MarkerTypes.User:
      return <UserMarker />;
    case MarkerTypes.StoreActive:
      return <StoreMarker />;
    case MarkerTypes.StoreInActive:
      return <StoreMarkerActive />;
    case MarkerTypes.StoreSelectedInactive:
      return <StoreMarkerInActive />;
    case MarkerTypes.StoreDisabled:
      return <StoreMarkerDisabled />;
    case MarkerTypes.StoreFavClosed:
      return <StoreMarkerFavClosed />;
    case MarkerTypes.StoreFavOpen:
      return <StoreMarkerFavorite />;
    case MarkerTypes.Driver:
      return <DriverMarker />;
    case MarkerTypes.Destination:
      return <DestinationMarker />;

    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export const deriveMarkerIconRevamp = (type: MarkerTypes): React.ReactNode => {
  switch (type) {
    case MarkerTypes.User:
      return <UserMarker />;
    case MarkerTypes.StoreActive:
      return <StoreMarkerRevamp />;
    case MarkerTypes.StoreInActive:
      return <StoreMarkerActiveRevamp />;
    case MarkerTypes.StoreSelectedInactive:
      return <StoreMarkerInActive />;
    case MarkerTypes.StoreDisabled:
      return <StoreMarkerDisabledRevamp />;
    case MarkerTypes.StoreFavClosed:
      return <StoreMarkerFavClosedRevamp />;
    case MarkerTypes.StoreFavOpen:
      return <StoreMarkerFavoriteRevamp />;
    case MarkerTypes.Driver:
      return <DriverMarker />;
    case MarkerTypes.Destination:
      return <DestinationMarker />;

    default:
      throw new Error(`Unsupported type: ${type}`);
  }
};

export const checkSingleUseMarker = (type: MarkerTypes): boolean =>
  [MarkerTypes.User, MarkerTypes.Driver, MarkerTypes.Destination].includes(type);

// this is just for mobile apps as after some research most of the performance issues was caused by SVG images
export const getKeyForMarkerInput = (
  { type, location }: IMarkerInput,
  isSingleUseMarker: boolean
): string => (isSingleUseMarker ? type : `${location.lat}${location.lng}`);

export const generateMarker = ({
  type,
  location,
  onPress,
  enableMapListExperiment,
}: IMarkerInput): IMarker => {
  const isSingleUseMarker = checkSingleUseMarker(type);
  const key = getKeyForMarkerInput({ type, location }, isSingleUseMarker);
  return {
    key,
    location,
    icon: enableMapListExperiment ? deriveMarkerIconRevamp(type) : deriveMarkerIcon(type),
    onPress,
    type,
    preventMarkerPress: isSingleUseMarker,
  };
};
